import React from 'react';
import * as _ from 'lodash';

import DecimalForGlobals from '../../support/impuestos/DecimalForGlobals';

const TotalGlobalSummary = ({ data }) => {

  const totalizador = () => {
    if (!data) {
      return {};
    }

    return {
      subtotal: DecimalForGlobals.make(parseFloat(data.SubTotal || '0.00')).toFixed(),
      descuento: data.Descuento || '0.00',
      total: data.Total || '0.00',
      traslados: _.get(data, 'Impuestos.TotalImpuestosTrasladados') || '0.00',
      retenciones: _.get(data, 'Impuestos.TotalImpuestosRetenidos') || '0.00'
    };
  }

  const totals = totalizador();

  return (
    <div className="text-right">
      <strong>Subtotal: </strong>
      <span className="amount-summary">{ DecimalForGlobals.make(totals.subtotal).toString() }</span>
      <br/>
      <strong>Descuento: </strong>
      <span className="amount-summary">{ DecimalForGlobals.make(totals.descuento).toString() }</span>
      <br/>
      <strong>Traslados: </strong>
      <span className="amount-summary">{ DecimalForGlobals.make(totals.traslados).toString() }</span>
      <br/>
      <strong>Retenciones: </strong>
      <span className="amount-summary">{ DecimalForGlobals.make(totals.retenciones).toString() || '0.00' }</span>
      <br/>
      <strong>Total: </strong>
      <span className="amount-summary">{ DecimalForGlobals.make(totals.total).toString() }</span>
      <br/>
    </div>
  )
}

export default TotalGlobalSummary;